import * as React from 'react';
import { BigNumber } from '../../../components/BigNumber';

interface StatsRowProps {
  orders: number;
  sales: number;
  tips: number;
  averageTipPercentage: number;
}

export const StatsRow = (props: StatsRowProps) => {
  return (
    <div className='delivery-location-live-stats-row'>
      <BigNumber title='Total Orders' data={props.orders} />
      <BigNumber title='Total Sales' data={`$${props.sales}`} />
      <BigNumber title='Total Tips' data={`$${props.tips}`} />
      <BigNumber title='Average Tip %' data={`${props.averageTipPercentage}%`} />
    </div>
  );
};
